import React, { useContext } from 'react';
import { useTranslate } from '@bynder/localization';
import { IconInbox } from '@bynder/icons';
import { SearchResults } from '../../../types';
import { Item } from './Item';
import { calculateHeightStyle } from './calculateHeightStyle';
import { iconSizeExtraLarge } from '../../../helpers/iconSizes';
import { InfoContext } from '../../../context';
import { addDomainToUrlIfNeeded } from '../../../helpers/url';

interface Props {
	searchTerm: string;
	results: SearchResults;
}

export function GroupCollections({ searchTerm, results }: Props) {
	const { translate } = useTranslate();
	const { collections } = results;
	const {
		general: { portalDomain },
	} = useContext(InfoContext);

	return (
		<>
			<li className="spotlight-allcollections">
				<a href="#" className="header no-click" onClick={onDisabledClick}>
					<i className="icon-transferbox hover-inverse active-inverse" />{' '}
					{translate('collections.allFor')} <b>{searchTerm}</b>
					<span>{collections.total}</span>
				</a>
			</li>
			<div className="spotlight-results" style={calculateHeightStyle(results)}>
				<ul>
					{collections.items.map((collection) => {
						const icon = collection.thumbnailUrl ? (
							<img
								src={addDomainToUrlIfNeeded(collection.thumbnailUrl, portalDomain)}
								alt=""
							/>
						) : (
							<IconInbox size={iconSizeExtraLarge} />
						);

						const linkToCollection = collection.path
							? collection.path
							: `/collections/view/${collection.id}/`;

						return (
							<Item
								item={collection}
								className="spotlight-collection"
								dataId={collection.id}
								key={collection.id}
							>
								<a href={linkToCollection}>
									<div className="searchbox-img">{icon}</div>
									<p
										className="searchbox-title"
										// eslint-disable-next-line react/no-danger
										dangerouslySetInnerHTML={{ __html: collection.name }}
									/>
									<p className="searchbox-description">
										{collection.description?.slice(0, 99)}
									</p>
									<span className="searchbox-info">
										{collection.mediaCount === undefined
											? collection.assetCount
											: collection.mediaCount}
									</span>
								</a>
							</Item>
						);
					})}
				</ul>
			</div>
		</>
	);
}

const onDisabledClick = (e: React.MouseEvent) => {
	e.stopPropagation();
	e.preventDefault();
};
